import * as React from 'react';
import { DragSource, DropTarget } from 'react-dnd';
import { findDOMNode } from 'react-dom';

import { ICrop } from '../../../../../../infrastructure/interfaces';
import DragTypes from '../../../../../../infrastructure/DragTypes';

export interface ICropImageProps {
  index: number;
  id: string;
  moveCrop?(dragIndex: number, hoverIndex: number): void;
  crop: ICrop;
  isDragging?: boolean;
  connectDragSource?: Function;
  connectDropTarget?: Function;
  imgStyle: {
    width: string;
    height: string;
    border: string;
  };
  style: {
    left: string;
    bottom: string;
  };
}

const cropSource = {
  beginDrag(props: ICropImageProps) {
    return {
      id: props.id,
      index: props.index,
    };
  },
};

const cropTarget = {
  hover(props: ICropImageProps, monitor: any, component: any) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;

    if (dragIndex === hoverIndex) {
      return;
    }

    const hoverBoundingRect = (findDOMNode(component) as any).getBoundingClientRect();
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
    const clientOffset = monitor.getClientOffset();
    const hoverClientY = clientOffset.y - hoverBoundingRect.top;

    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
      return;
    }

    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
      return;
    }

    if (props.moveCrop) {
      props.moveCrop(dragIndex, hoverIndex);
      monitor.getItem().index = hoverIndex;
    }
  },
};
@DropTarget(DragTypes.CROP, cropTarget, (connect: any) => ({
  connectDropTarget: connect.dropTarget(),
}))
@DragSource(DragTypes.CROP, cropSource, (connect: any, monitor: any) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging(),
}))

export default class CropImage extends React.PureComponent<ICropImageProps> {
  render() {
    const {
      crop,
      isDragging,
      connectDragSource,
      connectDropTarget,
      style,
      imgStyle,
    } = this.props;
    const opacity = isDragging ? 0.5 : 1;

    if (connectDragSource && connectDropTarget) {
      return connectDragSource(
        connectDropTarget(
          <div className="front-cover-crop" style={{ opacity, ...style }}>
            <img
              alt={crop.name}
              src={crop.defaultImage}
              style={imgStyle}
            />
          </div>),
      );
    }

    return (<div className="front-cover-crop"></div>);

  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/common/FrontLayout/CropImage.tsx